import { useDispatch } from "react-redux";
import { clearCompleted } from "../redux/todos/actions";

export default function CompleteTodoHeader() {
  const dispatch = useDispatch();

  const clearHeandler = () => {
    dispatch(clearCompleted());
  };

  return (
    <div>
      <ul className="flex justify-between items-end mb-2 text-xs text-gray-500">
        <li>
          <h3 className="font-medium text-lg text-black">Completed Tasks</h3>
        </li>
        <li className="cursor-pointer" onClick={clearHeandler}>
          Clear completed
        </li>
      </ul>
    </div>
  );
}
